import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete'
import TextField, { TextFieldProps } from '@mui/material/TextField'

type MultiSelectProps = Omit<AutocompleteProps<any, true, boolean, false>, 'renderInput'> & {
  inputProps?: TextFieldProps
}

export default function MultiSelect({ inputProps, ...props }: MultiSelectProps) {
  return (
    <Autocomplete
      multiple
      renderInput={(params) => (
        <TextField {...params} variant="outlined" margin="dense" {...inputProps} />
      )}
      {...props}
    />
  )
}
